const holder: HTMLImageElement[] = [];

export async function preloadImages() {
  const images = import.meta.glob('@/assets/images/*.{png,jpg,jpeg,svg}', {
    eager: true,
    import: 'default',
  });

  await Promise.all(
    Object.values(images).map(async (src) => {
      const img = new Image();
      img.src = src as string;
      await img.decode();
      holder.push(img);
    }),
  );
}
